import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// Remove Emergent watermark badge if present
const removeBadge = () => {
  const badge = document.getElementById('emergent-badge');
  if (badge) badge.remove();
};
removeBadge();
setTimeout(removeBadge, 500);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
